import apiRoute from "@/router/api-routes";
import secondHttp from "@/plugins/secondHttps";
import http from "@/plugins/https"
import store from "@/store"

/**
 * Client HTTP unifié pour gérer les requêtes
 */
const httpClient = async ({ method, url, data = null, params = null }) => {
  const config = { method, url, data, params };
  const response = await secondHttp(config);

  // Vérification de la réponse
  if (!response || !response) {
    throw new Error(`Réponse invalide de l'API : ${JSON.stringify(response)}`);
  }

  return response;
};

const httpOld = async ({ method, url, data = null, params = null }) => {
  const config = { method, url, data, params };
  const response = await http(config);

  // Vérification de la réponse
  if (!response || !response) {
    throw new Error(`Réponse invalide de l'API : ${JSON.stringify(response)}`);
  }

  return response;
};

// Create chartered accountant
export const createCharteredAccountant = (data) => { 
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURLAccountant}${apiRoute.create_chartered_accountant}`,
    data,
  });
};

// Get all chartered accountant
export const getAccountant = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_all_accountant}`,
    params: data,
  });
};

// Upload file
export const uploadFile = (data) => {
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURLAccountant}${apiRoute.upload_file}`,
    data,
  });
};

// Get all affected enterprise
export const getAffected = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_all_affected}`,
    params: data,
  });
};

// Create new affectation
export const createAffectation = (data) => {
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURLAccountant}${apiRoute.create_affectation}`,
    data,
  });
};

// Get accountant statistics
export const getAccountantStats = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.accountant_stats}`,
    params: data,
  });
};

// Create service
export const createService = (data) => {
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURLAccountant}${apiRoute.create_service}`,
    data,
  });
};

// Get service for extern
export const getService = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_all_service_for_extern}`,
    params: data,
  });
};

// Get service request
export const getServiceRequest = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_all_service_request}`,
    params: data,
  });
};

// update service request
export const updateServiceRequest = (data) => {
  return httpClient({
    method: "patch",
    url: `${apiRoute.baseURLAccountant}${apiRoute.update_service_request}`,
    data,
  });
};

// Get request expert
export const getRequestExpert = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_all_request_expert}`,
    params: data,
  });
};

// update request expert
export const updateRequestExpert = (data) => {
  return httpClient({
    method: "patch",
    url: `${apiRoute.baseURLAccountant}${apiRoute.update_request_expert}`,
    data,
  });
};

// Get request program
export const getRequestProgram = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.allSfd}`,
    params: data,
  });
};

// Get request admin global data
export const getAdminGlobalData = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_stats_admin}`,
    params: data,
  });
};

// get expert stats
export const getExpertStats = (data) => {
  return httpClient({
    method: "get",
    url: `${apiRoute.baseURLAccountant}${apiRoute.get_expert_stats}`,
    params: data,
  });
};

// Get all comptable
export const getAllCompta = (data) => {
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURL}${apiRoute.get_all_comptable}`,
    data,
  });
};

// update service 
export const updateService = (data) => {
  return httpClient({
    method: "patch",
    url: `${apiRoute.baseURLAccountant}${apiRoute.update_service}`,
    data,
  });
};

// Create chartered accountant
export const stateGraph = (data) => { 
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURL}${apiRoute.get_stats_signup}`,
    data,
  });
};

// Delete admin
export const deleteAdmin = (id) => { 
  return httpOld({
    method: "delete",
    url: `${apiRoute.baseURL}${apiRoute.deleteAdmin(id)}`,
  });
};

// Désactiver un admin
export const desactiveAdmin = (id) => {
  return httpOld({
    method: "patch",
    url: `${apiRoute.baseURLAccountant}${apiRoute.desactiveAdmin(id)}`,
  });
};

// Réactiver un admin
export const reactiveAdmin = (id) => {
  return httpOld({
    method: "patch",
    url: `${apiRoute.baseURLAccountant}${apiRoute.reactiveAdmin(id)}`,
  });
};

// Recupe2ration des entreprises
export const allCommerceTrue = ({ params }) => {
  return httpOld({
    method: "get",
    url: `${apiRoute.baseURL}${apiRoute.get_all_commerce}`,
    params
  });
};

// Upload file
export const relaunchSms = (data) => {
  return httpOld({
    method: "post",
    url: `${apiRoute.baseURL}${apiRoute.relaunch_sms}`,
    data,
  });
};

// Delete sfd
export const deleteSfd = (id) => { 
  return httpOld({
    method: "delete",
    url: `${apiRoute.baseURL}${apiRoute.deleteSfd(id)}`,
  });
};

// Update sfd
export const updateSfd = (data) => { 
  return httpOld({
    method: "patch",
    url: `${apiRoute.baseURL}${apiRoute.updateSfd}`,
    data,
  });
};

// Upload file
export const exportExcelCommerce = (data) => {
  return httpOld({
    method: "post",
    url: `${apiRoute.baseURL}${apiRoute.exportExcelCommerce}`,
    data
  });
};

// Send invitation to accountant by email
export const sendInvitationAccountant = (data) => {
  return httpClient({
    method: "post",
    url: `${apiRoute.baseURLAccountant}${apiRoute.sendInvitationAccountant}`,
    data,
  });
}

// export all comptable
export const exportExcelInfo = async (data) => {
  return await httpOld({
    method: "post",
    url: `${apiRoute.baseURL}${apiRoute.exportExcelInfo}`,
    data,
    // withCredentials: true,
    // headers: {
    //   'x-api-key': '1ab2c3d4e5f61ab2c3d4e5f6',
    //   'Authorization': 'Bearer ' + store.getters.token
    // }
  });
}

// limitate view
export const limitateView = (id, data) => { 
  return httpOld({
    method: "patch",
    url: `${apiRoute.baseURL}${apiRoute.limitate_view(id)}`,
    data,
  });
};